// The company behind jynio.co, as registered (Insee / RNE), and its host.
// One place for the facts the legal notice (LCEN Art. 6-III) and the Privacy
// Policy print, so the two can't disagree. Proper names and registry numbers
// stay as registered in every language; only the labels around them are
// translated (legalNotice.* in the locale files). #683.
export const LEGAL_ENTITY = {
  name: "JYNIO",
  legalForm: "Société par actions simplifiée (SAS)",
  shareCapital: "1 €",
  registration: "RCS Paris 106 155 245",
  siret: "106 155 245 00017",
  vatNumber: "FR03106155245",
  address: "47 rue Vivienne, 75002 Paris, France",
  phone: "+33 6 52 98 10 30",
  email: "hello@jynio.co",
  publicationDirector: "Valentin Hervouet",
} as const;

// Address from Fly.io's Terms of Service, phone from its ARIN registry contact
// (Fly.io's own documents give none).
export const HOST = {
  name: "Fly.io, Inc.",
  address: "2261 Market Street #4990, San Francisco, CA 94114, USA",
  phone: "+1 510-768-8430",
  website: "https://fly.io",
} as const;
